export default function Reports() {
  return (
    <>
      <div className="screen active" id="screen-reports">
        <div className="page-head">
          <div>
            <h1>Reports</h1>
            <div className="ph-sub">
              Generate filtered reports for any period
            </div>
          </div>
        </div>
        <div className="grid-2">
          <div className="card">
            <div className="card-title">Report filters</div>
            <div className="form-grid">
              <div className="field">
                <label>From date</label>
                <input type="date" defaultValue="2026-08-01" />
              </div>
              <div className="field">
                <label>To date</label>
                <input type="date" defaultValue="2026-08-31" />
              </div>
            </div>
            <div className="form-grid">
              <div className="field">
                <label>Biller</label>
                <select id="report-biller">
                  <option>All billers</option>
                  <option>All Electricity billers</option>
                  <optgroup label="Electricity">
                    <option>Adani Electricity Mumbai Limited</option>
                    <option>AEML SEEPZ Limited</option>
                    <option>Ajmer Vidyut Vitran Nigam Limited (AVVNL)</option>
                    <option>
                      Andhra Pradesh Central Power Distribution Corporation
                      Limited
                    </option>
                    <option>
                      Assam Power Distribution Company Ltd (NON-RAPDR)
                    </option>
                    <option>
                      Assam Power Distribution Company Ltd- Smart Prepaid
                      Recharge
                    </option>
                    <option>B.E.S.T Mumbai</option>
                    <option>
                      Bangalore Electricity Supply Co. Ltd (BESCOM)
                    </option>
                    <option>Bharatpur Electricity Services Ltd. (BESL)</option>
                    <option>Bikaner Electricity Supply Limited (BkESL)</option>
                    <option>CESC Limited</option>
                    <option>
                      Chamundeshwari Electricity Supply Corp Ltd (CESCOM)
                    </option>
                    <option>
                      Chhattisgarh State Power Distribution Co. Ltd
                    </option>
                    <option>
                      Dadra and Nagar Haveli and Daman and Diu Power
                      Distribution Corporation Limited
                    </option>
                    <option>
                      Dakshin Gujarat Vij Company Limited (DGVCL)-Fetch and pay
                    </option>
                    <option>
                      Department of Power, Government of Arunachal Pradesh
                    </option>
                    <option>
                      Department of Power, Government of Arunachal Pradesh -
                      Prepaid
                    </option>
                    <option>Department of Power, Nagaland</option>
                    <option>DNH Power Distribution Company Limited</option>
                    <option>
                      Eastern Power Distribution Company of AP Ltd.
                    </option>
                    <option>Electricity Department Chandigarh</option>
                    <option>Gift Power Company Limited</option>
                    <option>Goa Electricity Department</option>
                    <option>
                      Government of Puducherry Electricity Department
                    </option>
                    <option>Gulbarga Electricity Supply Company Limited</option>
                    <option>Himachal Pradesh State Electricity Board</option>
                    <option>
                      Hukkeri Rural Electric CoOperative Society Ltd
                    </option>
                    <option>India Power Corporation Limited (IPCL)</option>
                    <option>India Power Prepaid Meter</option>
                    <option>Jaipur Vidyut Vitran Nigam (JVVNL)</option>
                    <option>
                      Jammu Power Distribution Corporation (JPDCL)
                    </option>
                    <option>
                      Jharkhand Bijli Vitran Nigam Limited - Prepaid Meter
                      Recharge
                    </option>
                    <option>
                      Jharkhand Bijli Vitran Nigam Limited (JBVNL)
                    </option>
                    <option>
                      Jodhpur Vidyut Vitran Nigam Limited (JDVVNL)
                    </option>
                    <option>
                      Kanan Devan Hills Plantations Company Private Limited
                    </option>
                    <option>
                      Kashmir Power Distribution Corporation Ltd (KPDCL)
                    </option>
                    <option>Kerala State Electricity Board Ltd. (KSEBL)</option>
                    <option>Kinesco Power and Utilities Pvt Ltd</option>
                    <option>
                      Kota Electricity Distribution Limited (KEDL)
                    </option>
                    <option>Ladakh Power Development Department (LPDD)</option>
                    <option>Lakshadweep Electricity Department</option>
                    <option>M.P. Madhya Kshetra Vidyut Vitaran - RURAL</option>
                    <option>M.P. Madhya Kshetra Vidyut Vitaran - URBAN</option>
                    <option>M.P. Paschim Kshetra Vidyut Vitaran</option>
                    <option>M.P. Poorv Kshetra Vidyut Vitaran Jabalpur</option>
                    <option>
                      Madhya Gujarat Vij Company Limited (MGVCL)-Fetch and pay
                    </option>
                    <option>Maharashtra State Electricity Distbn Co Ltd</option>
                    <option>Malegaon Power Supply Ltd</option>
                    <option>
                      Mangalore Electricity Supply Co. Ltd (MESCOM) - RAPDR
                    </option>
                    <option>
                      Mangalore Electricity Supply Company LTD (Non RAPDR)
                    </option>
                    <option>
                      Manipur State Power Distribution Company Limited
                    </option>
                    <option>Meghalaya Power Dist Corp Ltd</option>
                    <option>MePDCL Smart Prepaid Meter Recharge</option>
                    <option>
                      New Delhi Municipal Council (NDMC) - Electricity
                    </option>
                    <option>Noida Power</option>
                    <option>North Bihar Power Distribution Company Ltd.</option>
                    <option>
                      Northern Power Distribution Company of Telangana Limited
                    </option>
                    <option>
                      Paschim Gujarat Vij Company Limited (PGVCL)-Fetch and pay
                    </option>
                    <option>
                      Power and Electricity Department - Mizoram - 10 Digit
                      Consumer Number
                    </option>
                    <option>Punjab State Power Corporation Ltd (PSPCL)</option>
                    <option>Sikkim Power - RURAL</option>
                    <option>Sikkim Power - URBAN</option>
                    <option>South Bihar Power Distribution Company Ltd.</option>
                    <option>
                      Southern Power Distribution Company of AP Ltd
                    </option>
                    <option>
                      Southern Power Distribution Company of Telangana Limited
                    </option>
                    <option>Spurt Electric Limited</option>
                    <option>
                      Tamil Nadu Power Distribution Corporation Limited (TNPDCL)
                    </option>
                    <option>Tata Power - Delhi</option>
                    <option>Tata Power - Mumbai</option>
                    <option>Tata Steel UISL</option>
                    <option>
                      The Co operative Electric Supply Society Ltd Sircilla
                    </option>
                    <option>Thrissur Corporation Electricity Department</option>
                    <option>Torrent Power</option>
                    <option>TP Ajmer Distribution Ltd (TPADL)</option>
                    <option>TP Central Odisha Distribution Ltd.</option>
                    <option>TP Northern Odisha Distribution Limited</option>
                    <option>TP Renewables Microgrid Ltd.</option>
                    <option>
                      TP Southen Odisha Distribution Ltd-Smart Prepaid Meter
                      Recharge
                    </option>
                    <option>TP Southern Odisha Distribution Limited</option>
                    <option>TP Western Odisha Distribution Limited</option>
                    <option>
                      TP Western Odisha Distribution Ltd-Smart Prepaid Meter
                      Recharge
                    </option>
                    <option>Tripura Electricity Corp Ltd</option>
                    <option>TTD Electricity</option>
                    <option>UPPCL CTS Prepaid Meter (GENUS)</option>
                    <option>
                      UPPCL-Postpaid and Smart Prepaid Meter Recharge
                    </option>
                    <option>
                      Uttar Gujarat Vij Company Limited (UGVCL)-Fetch and pay
                    </option>
                    <option>Uttar Haryana Bijli Vitran Nigam (UHBVN)</option>
                    <option>Uttarakhand Power Corporation Limited</option>
                    <option>
                      Uttarakhand Power Corporation Limited - Smart Prepaid
                      Recharge
                    </option>
                    <option>Vaghani Energy Limited</option>
                    <option>West Bengal Electricity</option>
                    <option>West Bengal Electricity Prepaid</option>
                  </optgroup>
                  <option>All FASTag billers</option>
                  <optgroup label="FASTag">
                    <option>Airtel Payments Bank NETC FASTag</option>
                    <option>AU Bank Fastag</option>
                    <option>Axis Bank Fastag</option>
                    <option>Bajaj Pay FASTag</option>
                    <option>Bandhan Bank Fastag</option>
                    <option>Bank of Baroda FASTag</option>
                    <option>Bank of Maharashtra FASTag</option>
                    <option>Blackbuck</option>
                    <option>Canara Bank Fastag</option>
                    <option>CUB FASTag</option>
                    <option>Equitas FASTag Recharge</option>
                    <option>Federal Bank - FASTag</option>
                    <option>HDFC Bank FASTag</option>
                    <option>ICICI Bank FASTag</option>
                    <option>IDBI Bank FASTag</option>
                    <option>IDFC FIRST Bank FASTag</option>
                    <option>Indian Bank Fastag Recharge</option>
                    <option>
                      Indian Highways Management Company Ltd FASTag
                    </option>
                    <option>IndusInd Bank FASTag</option>
                    <option>IOB FASTag</option>
                    <option>Jammu and Kashmir Bank FASTag</option>
                    <option>Karnataka Bank FASTag</option>
                    <option>Kotak Mahindra Bank FASTag</option>
                    <option>KVB Fastag</option>
                    <option>LivQuik Technology India Private Limited</option>
                    <option>Paul Merchants</option>
                    <option>Punjab National Bank FASTag</option>
                    <option>Saraswat Bank - FASTag</option>
                    <option>South Indian Bank Fastag</option>
                    <option>State Bank of India - NETC FASTag</option>
                    <option>
                      Transaction Analyst (T Wallet, TA Wallet and TAG-ITI
                      Wallet)
                    </option>
                    <option>Transcorp International Limited</option>
                    <option>UCO Bank FASTag</option>
                    <option>Union Bank of India FASTag</option>
                    <option>Yes Bank FASTag</option>
                  </optgroup>
                  <option>All Landline Postpaid billers</option>
                  <optgroup label="Landline Postpaid">
                    <option>Airtel Landline (Fetch and Pay)</option>
                    <option>BSNL Landline - Corporate</option>
                    <option>BSNL Landline - Individual</option>
                    <option>MTNL Delhi</option>
                    <option>MTNL Mumbai</option>
                    <option>MTNL Mumbai (Multiple Bills)</option>
                    <option>MTNL Mumbai Lease Circuit</option>
                    <option>Tata Teleservices</option>
                  </optgroup>
                  <option>All Mobile Postpaid billers</option>
                  <optgroup label="Mobile Postpaid">
                    <option>Airtel Postpaid (Fetch and Pay)</option>
                    <option>BSNL Mobile Postpaid</option>
                    <option>Jio Postpaid</option>
                    <option>Jio Postpaid (Fetch and Pay)</option>
                    <option>Tata Teleservices</option>
                    <option>Wiwanet Solution Pvt Ltd</option>
                  </optgroup>
                </select>
              </div>
              <div className="field">
                <label>Status</label>
                <select>
                  <option>All statuses</option>
                  <option>Success</option>
                  <option>Pending</option>
                  <option>Failed</option>
                </select>
              </div>
            </div>
            <button className="btn btn-primary" onclick="generateReport()">
              Generate report
            </button>
          </div>
          <div
            className="card"
            id="report-result-card"
            style={{ display: "none" }}
          >
            <div className="card-title">Report ready</div>
            <div className="card-sub" id="report-result-sub">
              —
            </div>
            <div style={{ display: "flex", gap: 10 }}>
              <button
                className="btn btn-ghost btn-sm"
                onclick="showToast('Excel report exported')"
              >
                Export Excel
              </button>
              <button
                className="btn btn-ghost btn-sm"
                onclick="showToast('PDF report exported')"
              >
                Export PDF
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
